export let ETabDiscoveryRoutes=function(ETabDiscoveryRoutes){ETabDiscoveryRoutes["TabDiscovery"]="TabDiscovery";return ETabDiscoveryRoutes;}({});